export default __webpack_public_path__ + "locales/ru/HotkeysPanel.json?hash=ba0b62db385f51a252d18bc86453828b";